export const SlideIcon = () => {
  return (
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="1"
        y="1"
        width="38"
        height="38"
        rx="4"
        fill="white"
        stroke="black"
        strokeWidth="2"
      />
      <rect x="4" y="11.4287" width="24" height="17.1429" fill="black" />
      <rect x="31.9999" y="11.4287" width="4" height="17.1429" fill="black" />
    </svg>
  );
};
export const CateconIcon = () => {
  return (
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="1"
        y="1"
        width="38"
        height="38"
        rx="4"
        fill="white"
        stroke="black"
        strokeWidth="2"
      />
      <mask id="path-2-inside-1_812_377" fill="white">
        <rect x="5.71436" y="12" width="11.4286" height="16" rx="1" />
      </mask>
      <rect
        x="5.71436"
        y="12"
        width="11.4286"
        height="16"
        rx="1"
        fill="black"
        stroke="black"
        strokeWidth="4"
        mask="url(#path-2-inside-1_812_377)"
      />
      <mask id="path-3-inside-2_812_377" fill="white">
        <rect x="22.8571" y="12" width="11.4286" height="16" rx="1" />
      </mask>
      <rect
        x="22.8571"
        y="12"
        width="11.4286"
        height="16"
        rx="1"
        fill="black"
        stroke="black"
        strokeWidth="4"
        mask="url(#path-3-inside-2_812_377)"
      />
    </svg>
  );
};
export const ScrollableconIcon = () => {
  return (
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="1"
        y="1"
        width="38"
        height="38"
        rx="4"
        fill="white"
        stroke="black"
        strokeWidth="2"
      />
      <rect
        x="1"
        y="9.88855"
        width="6.88889"
        height="20.2222"
        rx="1"
        fill="black"
        stroke="black"
        strokeWidth="2"
      />
      <rect
        x="14.3335"
        y="9.88855"
        width="11.3333"
        height="20.2222"
        rx="1"
        fill="black"
        stroke="black"
        strokeWidth="2"
      />
      <rect
        x="32.1111"
        y="9.88855"
        width="6.88889"
        height="20.2222"
        rx="1"
        fill="black"
        stroke="black"
        strokeWidth="2"
      />
    </svg>
  );
};

export const DragIcon = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="20" height="20" rx="5" fill="white" />
      <rect
        x="2.66663"
        y="2.66663"
        width="5.33333"
        height="5.33333"
        rx="2.66667"
        fill="#808080"
      />
      <rect
        x="2.66663"
        y="12"
        width="5.33333"
        height="5.33333"
        rx="2.66667"
        fill="#808080"
      />
      <path
        d="M12 5.33329C12 3.86053 13.1939 2.66663 14.6667 2.66663C16.1394 2.66663 17.3333 3.86053 17.3333 5.33329C17.3333 6.80605 16.1394 7.99996 14.6667 7.99996C13.1939 7.99996 12 6.80605 12 5.33329Z"
        fill="#808080"
      />
      <path
        d="M12 14.6667C12 13.1939 13.1939 12 14.6667 12C16.1394 12 17.3333 13.1939 17.3333 14.6667C17.3333 16.1394 16.1394 17.3333 14.6667 17.3333C13.1939 17.3333 12 16.1394 12 14.6667Z"
        fill="#808080"
      />
    </svg>
  );
};

export const Addicon = () => {
  return (
    <svg
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="15" cy="15" r="15" fill="#495464" />
      <rect x="13.5" y="7.5" width="3" height="15" rx="1.5" fill="white" />
      <rect
        x="7.5"
        y="16.5"
        width="3"
        height="15"
        rx="1.5"
        transform="rotate(-90 7.5 16.5)"
        fill="white"
      />
    </svg>
  );
};

export const BannerHomeIcon = () => {
  return (
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="1"
        y="1"
        width="38"
        height="38"
        rx="4"
        fill="white"
        stroke="black"
        strokeWidth="2"
      />
      <rect
        x="6"
        y="10"
        width="28"
        height="20.2222"
        rx="1"
        fill="black"
        stroke="black"
        strokeWidth="2"
      />
    </svg>
  );
};
